module.exports = __webpack_public_path__ + "assets/img/5_1375_big.be65a9cb.jpg";